/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_AssistantInputs */



/**
* | output |
* | --- |
* | "AI Assistant" |
*
* @param {Ai_AssistantInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ai_assistant = /** @type {((inputs?: Ai_AssistantInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_AssistantInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Assistant IA")
	if (locale === "de") return /** @type {LocalizedString} */ ("KI-Assistent")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assistente AI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ИИ-помощник")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asistente de IA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("人工智能助手")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIアシスタント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई सहायक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Assistente de IA")
	return /** @type {LocalizedString} */ ("AI Assistant")
});